import * as React from 'react';
import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';
import TextField, { TextFieldChangeHandler, TextFieldLabelPosition, TextFieldProps } from '../common/TextField';
import SplitProgress, { SplitProgressProps } from './SplitProgress'
import { CheckSummary } from '../../models/common/CheckSummary';
import { CheckStateContext } from '../../providers/CheckStateContextProvider';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { CheckClaimSummary } from '../../models/common/CheckClaimSummary';
import themePrimary from '../../styles/themePrimary';
import { String_Split_SplitByAmountPayLabel, String_Split_SplitByAmountOfLabel, 
    String_Split_SplitByAmountClaimSummaryString } from '../../utilities/StringHelper';

const useStyles = makeStyles({
    innerContainer: {
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    outerContainer: {
        width: '100%',
        display: 'flex',
    },
    instructionText: {
        textAlign: 'center',
        marginLeft: ElementDimensions.margin5 + 'px',
        marginRight: ElementDimensions.margin5 + 'px',
        marginBottom: ElementDimensions.margin10 + 'px ',
    },
    root: {
        padding: ElementDimensions.padding20 + 'px',
        backgroundColor: themePrimary.palette.grey[100],
        width: '100%',
    },
    splitText1: {
        textAlign: 'right',
        marginRight:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
    splitText2: {
        textAlign: 'left',
        marginLeft:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
});

export type SplitByAmountChangeHandler = (newValue: number) => any;

export interface SplitByAmountProps {
    checkSummary: CheckSummary;
    claimSummary: CheckClaimSummary | null;
    onChangeHandler: SplitByAmountChangeHandler;
}

const SplitByAmount = (props: SplitByAmountProps) => {
    const { checkSummary, claimSummary, onChangeHandler } = props;
    const isPortrait = true;    
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const [splitAmount, setSplitAmount] = React.useState<number>(0);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

        React.useEffect(() => {
        
        }, []);
    
    const handleSplitAmountTextChange: TextFieldChangeHandler = (newValue: string) => {
        let newAmount: number = 0;
        if (newValue.trim() === '') {
            newAmount = 0;
        }
        else {
            
            newAmount = Math.round(parseFloat(newValue) * 100);
            if (newAmount < 0) {
                newAmount = 0
            }
        }

        setSplitAmount(newAmount);
        onChangeHandler(newAmount);
    };

    const splitAmountTextFieldProps: TextFieldProps = {
        type: 'number',
        label: null,
        text: splitAmount <= 0 ? '' : splitAmount.toString(),
        width: 120,
        disabled: false,
        labelPosition: TextFieldLabelPosition.None,
        onChangeHandler: handleSplitAmountTextChange,
    }

    const splitProgressProps: SplitProgressProps = {
        progress: claimSummary !== null ? claimSummary.percent_unclaimed : 0,
        label: claimSummary !== null ? String_Split_SplitByAmountClaimSummaryString(claimSummary.amount_unclaimed_string, checkSummary.total_string).find(s => s.key === userState.state.locale)!!.value : '',
    }

    return (
        <div className={classes.root}>
            <SplitProgress 
                progress={splitProgressProps.progress}
                label={splitProgressProps.label} />

            <div className={classes.outerContainer}>
                <div className={classes.innerContainer}>
                    <Typography variant="body1" className={classes.splitText1}>
                        {String_Split_SplitByAmountPayLabel.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                    <TextField 
                        type={splitAmountTextFieldProps.type}
                        label={splitAmountTextFieldProps.label}
                        text={splitAmountTextFieldProps.text}
                        width={splitAmountTextFieldProps.width}
                        disabled={splitAmountTextFieldProps.disabled}
                        labelPosition={splitAmountTextFieldProps.labelPosition}
                        onChangeHandler={splitAmountTextFieldProps.onChangeHandler} />
                    <Typography variant="body1" className={classes.splitText2}>
                        {String_Split_SplitByAmountOfLabel.find(s => s.key === userState.state.locale)!!.value} {checkSummary.amount_due_string}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default SplitByAmount;
